import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { passwordStrength } from "check-password-strength";
import classNames from "classnames";
import classes from "./passwordSlider.module.scss";

export const PasswordChecker = ({ password }) => {
  const strength = passwordStrength(password);
  const strengthValue = strength.value;

  return (
    <div>
      <div className="d-flex align-items-center">
        <div className={classes["slider-wrapper"]}>
          <div
            className={classNames(
              classes["slider"],
              classes[strengthValue.split(" ").join("-")]
            )}
            style={{
              width: strength.id * 33.33334 + "%",
            }}
          />
        </div>
        <span className={classes["strength-value"]}>{strengthValue}</span>
      </div>
      <div className={"font-14 mt-2"}>Password must contain:</div>

      <ul className={classes["password-helper"]}>
        <li>
          {strength.length >= 8 ? (
            <CheckIcon className={classes.checked} />
          ) : (
            <XMarkIcon />
          )}
          at least 8 characters
        </li>
        <li>
          {strength.contains.includes("lowercase") &&
          strength.contains.includes("uppercase") ? (
            <CheckIcon className={classes.checked} />
          ) : (
            <XMarkIcon />
          )}
          uppercase and lowercase letters
        </li>
        <li>
          {strength.contains.includes("number") ? (
            <CheckIcon className={classes.checked} />
          ) : (
            <XMarkIcon />
          )}
          at least one number
        </li>
        <li>
          {strength.contains.includes("symbol") ? (
            <CheckIcon className={classes.checked} />
          ) : (
            <XMarkIcon />
          )}
          special letters (!#@*?)
        </li>
      </ul>
    </div>
  );
};
